// import { getSelectedPerson } from "../utils/auth";
import { getSelectedCompany } from "../utils/auth";
import { getRegisterId } from "../utils/authId";

const frontendUrl = process.env.REACT_APP_FRONTEND_SOCKET_URL;

class WebSocketService {
  static instance = null;
  socket = null;
  reconnectAttempts = 0;
  maxReconnectAttempts = 5;
  callbacks = {
    onmessage: null,
    onclose: null,
    onerror: null,
  };

  currentChatUnique = null; // Track current chat ID

  constructor() {
    if (WebSocketService.instance) {
      return WebSocketService.instance;
    }
    WebSocketService.instance = this;
  }

  connect(token, id, grpId) {
    if (this.pendingReconnect) {
      clearTimeout(this.pendingReconnect);
      this.pendingReconnect = null;
    }
    // const selectedUser = getSelectedPerson() || {};
    if (this.socket && this.currentChatUnique === id) {
      return;
    }
    if (this.socket && this.currentChatUnique !== id) {
      this.disconnect();
    }
    this.currentChatUnique = id;
    this.currentChatGroupType = grpId; // <- save grpId here

    this.socket = new WebSocket(`${frontendUrl}/ws/chat/${id}/?token=${token}`);
    // console.log(this.socket);
    this.socket.onopen = () => {
      this.reconnectAttempts = 0;
      this.markMessageAsRead(this.currentChatGroupType, this.currentChatUnique);
    };

    this.socket.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        this.callbacks.onmessage && this.callbacks.onmessage(data);
      } catch (error) {}
    };
    this.socket.onclose = (event) => {
      // Skip if this is not the current active socket
      if (event.target !== this.socket) return;

      this.socket = null;

      this.callbacks.onclose && this.callbacks.onclose(event);

      if (
        event.code !== 1000 &&
        this.reconnectAttempts < this.maxReconnectAttempts
      ) {
        const timeout = Math.min(1000 * 2 ** this.reconnectAttempts, 30000);
        this.pendingReconnect = setTimeout(() => {
          this.reconnectAttempts++;
          this.connect(token, id);
        }, timeout);
      } else {
        this.currentChatUnique = null;
      }
    };

    this.socket.onerror = (error) => {
      this.callbacks.onerror && this.callbacks.onerror(error);
    };
  }
  markMessageAsRead(grpId, uniqueId) {
    // console.log("-=-=-=-()");
    // const selectedUser = getSelectedPerson() || {};

    const registerId = getRegisterId();

    const readStatusPayload = {
      type: "read_update",
      register_id: registerId,
      chat_name:
        grpId === "0" ? "private" : grpId === "1" ? "group" : "channel",
      chat_unique_id: uniqueId,
    };
    this.sendMessage(readStatusPayload);
  }
  isConnecting() {
    return this.socket?.readyState === WebSocket.CONNECTING;
  }

  typingUser(id) {
    // const selectedUser = getSelectedPerson();
    const typingPapload = {
      type: "typing",
      chat_unique_id: id,
    };
    this.sendMessage(typingPapload);
  }

  // In your WebSocketService class
  sendReaction(messageId, chat_unique, emoji, type) {
    // const selectedUser = getSelectedPerson() || {};
    const registerId = getRegisterId();
    const companyId = getSelectedCompany();

    const reactionPayload = {
      add_remove_emoji: type,
      type: "reaction",
      message_id: messageId, // You'll need to track message IDs
      react_emoji: emoji,
      react_people: [registerId],
      chat_unique_id: chat_unique,
      company_id: companyId.id,
    };
    this.sendMessage(reactionPayload);
  }
  sendMessage(messageData) {
    if (this.socket?.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify(messageData));
    } else {
    }
  }

  registerCallbacks({ onmessage, onclose, onerror }) {
    if (onmessage) this.callbacks.onmessage = onmessage;
    if (onclose) this.callbacks.onclose = onclose;
    if (onerror) this.callbacks.onerror = onerror;
  }

  disconnect() {
    if (this.pendingReconnect) {
      clearTimeout(this.pendingReconnect);
      this.pendingReconnect = null;
    }

    if (this.socket) {
      this.socket.close(1000, "User initiated disconnect");
      this.socket = null;
      this.currentChatUnique = null;
    }
  }
}

const websocketservice = new WebSocketService();
export default websocketservice;
